// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d35d18aef668139ddc78","655":"ef458a419bde5483b64e"}[chunkId] + ".js";
};